<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">Add Option Details Type
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content>
    <table class="table editTable">
        <tr>
            <td  colspan="2" class="w-2/4 px-3">
                Item Name 
            </td>
        </tr>
        <tr>
            <td   colspan="2" class="px-3">
                <mat-form-field class="w-full">
                    <input matInput  [(ngModel)]="optionItem.name">
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td class="px-3">
                Alternate
            </td>
        </tr>
        <tr>
            <td class="px-3">
                <mat-form-field class="w-full">
                    <input matInput  [(ngModel)]="optionItem.alternate">
                </mat-form-field>
            </td>
        </tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" [disabled]="optionItem.name == '' || optionItem.alternate == '' || isLoading" (click)="addOptionsItem()">
        <span *ngIf="isLoading" class="loading loading-ring loading-sm"></span>
        {{ isLoading ? 'Creating..' : 'Create' }}</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>